import { makeApiRequest } from '@/src/lib/api-request'
import { formatDate } from '@/src/lib/utils'
import { useToken } from '@/src/store/token-store'
import { useUser } from '@/src/store/user-store'
import { useQuery } from '@tanstack/react-query'

export const useBillingCycleTotal = () => {
  let currentDate = new Date()
  let firstOfMonth = new Date(
    Date.UTC(
      currentDate.getUTCFullYear(),
      currentDate.getUTCMonth(),
      1,
      0,
      0,
      0
    )
  )
  let currentDateTime = new Date(
    Date.UTC(
      currentDate.getUTCFullYear(),
      currentDate.getUTCMonth(),
      currentDate.getUTCDate(),
      currentDate.getUTCHours(),
      currentDate.getUTCMinutes(),
      currentDate.getUTCSeconds()
    )
  )

  const { user, _hasHydrated } = useUser()
  const { accessToken } = useToken()

  let isBreakdownPage = false

  if (typeof window !== 'undefined') {
    isBreakdownPage = window.location.pathname === '/earnings/breakdown'
  }

  return useQuery({
    queryKey: ['billing-cycle-total', user],
    queryFn: async () => {
      const data: Record<string, any> = {}

      if (isBreakdownPage) {
        data.startDate = formatDate(firstOfMonth)
        data.endDate = formatDate(currentDateTime)
      }

      const response = await makeApiRequest({
        method: 'POST',
        url: '/Earning/getCurrentBillCycle',
        isAuthenticated: true,
        data,
        fallbackError: 'Error while fetching Current billing cycle',
        isV3Api: true,
      })
      return response.response
    },
    enabled: !!_hasHydrated && !!accessToken,
    refetchOnWindowFocus: false,
  })
}
